export default __webpack_public_path__ + "static/media/Tigers.f37aa9b5.PNG";